import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api, { apiErrorMessage } from "@/lib/api";
import { DELIVERY } from "@/constants/testIds";

const EMPTY = { key: "", label: "", description: "", base_fee_cents: null, per_mile_cents: null, status: "active" };

export default function AdminDeliveryZones() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [err, setErr] = useState("");

  const reload = async () => {
    try { const { data } = await api.get("/admin/delivery/zones"); setRows(data); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };
  useEffect(() => { reload(); }, []);

  const save = async () => {
    try { await api.post("/admin/delivery/zones", form); setForm(EMPTY); await reload(); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };
  const del = async (key) => {
    if (!window.confirm(`Delete zone ${key}?`)) return;
    await api.delete(`/admin/delivery/zones/${key}`); await reload();
  };

  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Delivery admin</div>
        <h1 className="headline-xl">Zones</h1>
        <p className="text-lifted-dim mt-2 text-sm">Per-zone fees override the global config. Empty = inherit from global.</p>
      </header>

      {err && <div className="text-rose-300 text-sm">{err}</div>}

      <section className="glass-panel p-5">
        <div className="eyebrow !text-lifted-text-dim mb-3">New / update zone</div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          <input className="input-lifted" placeholder="key (slug)" value={form.key} onChange={(e) => setForm({ ...form, key: e.target.value })} />
          <input className="input-lifted md:col-span-2" placeholder="label" value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} />
          <input className="input-lifted" type="number" placeholder="base fee ¢" value={form.base_fee_cents ?? ""} onChange={(e) => setForm({ ...form, base_fee_cents: e.target.value === "" ? null : parseInt(e.target.value,10) })} />
          <input className="input-lifted" type="number" placeholder="per-mile ¢" value={form.per_mile_cents ?? ""} onChange={(e) => setForm({ ...form, per_mile_cents: e.target.value === "" ? null : parseInt(e.target.value,10) })} />
          <input className="input-lifted md:col-span-5" placeholder="description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
        </div>
        <button onClick={save} className="btn-lifted mt-4 !text-[0.7rem]"><Plus className="h-3 w-3" /> Save zone</button>
      </section>

      <div data-testid={DELIVERY.zonesList} className="glass-panel overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[0.7rem] tracking-[0.22em] uppercase text-lifted-mute font-bebas border-b border-white/5">
              <th className="px-4 py-3">Key</th><th>Label</th><th>Base</th><th>Per-mile</th><th>Status</th><th className="text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((z) => (
              <tr key={z.key} className="border-b border-white/5">
                <td className="px-4 py-3"><code className="text-lifted-green text-xs">{z.key}</code></td>
                <td>{z.label}</td>
                <td className="text-lifted-text">{z.base_fee_cents == null ? "—" : `${z.base_fee_cents}¢`}</td>
                <td className="text-lifted-text">{z.per_mile_cents == null ? "—" : `${z.per_mile_cents}¢`}</td>
                <td><span className="chip chip--green">{z.status}</span></td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => del(z.key)} className="btn-ghost !py-1.5 !px-3 !text-[0.65rem] hover:!text-rose-300"><Trash2 className="h-3 w-3" /></button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-lifted-mute">No zones yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
